import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';
import bgGrid from "../assets/backgrounds/grid.svg"

//import Components
import Sidebar from './Sidebar';
import Footer from './Footer';
import RightSidebar from '../Components/Common/RightSidebar';

//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility
} from "../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import { AppDispatch, RootState } from 'store';
import eventEmitter from 'utils/eventEmitter';
import ErrorBoundary from './ErrorBoundary';
import Header from './Header';
import AddSocialAccount from 'Components/social-account/AddSocialAccount';
import { closeSocialPostModal, toggleAddGSTModalVisibility, toggleAddSocialAccountOffcanvas, toggleManageCollectionModal } from 'slices/ui/reducer';
import SocialPostModal from 'Components/social-account/SocialPostModal';
import { useLocation, useNavigate } from 'react-router-dom';
import { onboardingStepSortOrder } from 'types/user';
import AddGSTModal from 'Components/account/AddGSTModal';
import ManageCollectionModal from 'Components/Common/ManageCollectionModal/ManageCollectionModal';
import PlanLimitExceededModal from 'Components/Common/PlanLimitExceededModal';
import useMsg91ChatWidget from 'hooks/useMsg91ChatWidget';


const Layout = (props: any) => {

    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();
    useMsg91ChatWidget();
    const addSocialAccountOffcanvasActive = useSelector((state: RootState) => state.ui.addSocialAccountOffcanvas.isActive);
    const socialPostModal = useSelector((state: RootState) => state.ui.socialPostModal);
    const selectLayoutProperties = createSelector(
        (state: any) => state.Layout,
        (layout) => ({
            layoutType: layout.layoutType,
            leftSidebarType: layout.leftSidebarType,
            layoutModeType: layout.layoutModeType,
            layoutWidthType: layout.layoutWidthType,
            layoutPositionType: layout.layoutPositionType,
            topbarThemeType: layout.topbarThemeType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            leftSidebarViewType: layout.leftSidebarViewType,
            leftSidebarImageType: layout.leftSidebarImageType,
            preloader: layout.preloader,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
        })
    );
    // Inside your component
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);

    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        dispatch]);
    /*
    call dark/light mode
    */
    const onChangeLayoutMode = (value: any) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };

    const [headerClass, setHeaderClass] = useState("");
    // class add remove in header
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });
    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    useEffect(() => {
        // const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        // if (sidebarVisibilitytype === 'show' || layoutType === "vertical" || layoutType === "twocolumn") {
        //     humberIcon.classList.remove('open');
        // } else {
        //     humberIcon.classList.add('open');
        // }
    }, [sidebarVisibilitytype, layoutType]);


    useEffect(() => {
        eventEmitter.on('error', console.log);
    }, [])

    const header = useSelector((state: RootState) => state.ui.header);

    const onboardingData = useSelector((state: RootState) => state.auth.selectedAgency?.onboarding_steps);
    const onboardingSteps = onboardingData ?? {};
    const navigate = useNavigate();
    const addGSTModalVisibility = useSelector((state: RootState) => state.ui.addGSTModalVisibility);
    const manageCollectionModal = useSelector((state: RootState) => state.ui.manageCollectionModal);

    const pendingOnboardingSteps = useMemo(() => {
        if (!onboardingSteps) return [];
        // return Object.entries(onboardingSteps).map(([key, step]) => ({ key, ...step })).sort((a, b) => a.sort_order - b.sort_order)
        // return Object.entries(onboardingSteps).map(([key, step]) => ({ key, ...step })).filter((step) => step.status === 'pending' || step.status === 'skip').sort((a, b) => a.sort_order - b.sort_order)
        return Object.entries(onboardingSteps).map(([key, step]) => ({ key, ...step })).filter((step) => step.status === 'pending').sort((a, b) => (onboardingStepSortOrder[a.key as keyof typeof onboardingStepSortOrder] ?? 999) - (onboardingStepSortOrder[b.key as keyof typeof onboardingStepSortOrder] ?? 999))
    }, [onboardingSteps])

    useEffect(() => {
        if (pendingOnboardingSteps.length > 0) {
            navigate({ pathname: '/onboarding', search: `?step=${pendingOnboardingSteps[0].key}`}, {state: {from:  location.pathname+location.search}})
        }
    }, [pendingOnboardingSteps])


    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header />
                {/* <Header
                    headerClass={headerClass}
                    layoutModeType={layoutModeType}
                    onChangeLayoutMode={onChangeLayoutMode} /> */}
                <img className='w-100 position-absolute z-n1' src={bgGrid} />
                <Sidebar layoutType={layoutType} />
                <div className="main-content">
                    <ErrorBoundary>
                        {props.children}
                    </ErrorBoundary>
                    <Footer />
                </div>
                {
                    addSocialAccountOffcanvasActive &&
                    <AddSocialAccount isOpen={addSocialAccountOffcanvasActive} onClose={() => dispatch(toggleAddSocialAccountOffcanvas(false))} />
                }
                <SocialPostModal
                    isOpen={!!socialPostModal}
                    onClose={() => dispatch(closeSocialPostModal())}
                    socialAccount={socialPostModal?.socialAccount}
                    influencer={socialPostModal?.influencer}
                    postId={socialPostModal?.postId}
                    disableComments={true}
                />
                <AddGSTModal
                    isOpen={addGSTModalVisibility}
                    onClose={() => dispatch(toggleAddGSTModalVisibility(false))}
                />
                <ManageCollectionModal
                    isOpen={!!manageCollectionModal}
                    onClose={() => dispatch(toggleManageCollectionModal(null))}
                    post={manageCollectionModal?.post ?? null}
                    creator={manageCollectionModal?.creator ?? null}
                    itemType={manageCollectionModal?.itemType ?? 'post'}
                    addMode={manageCollectionModal?.addMode ?? true}
                    currentCollectionId={manageCollectionModal?.currentCollectionId}
                />
                <PlanLimitExceededModal />
            </div>
            {/* <RightSidebar /> */}
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);